export const RESPONSIVE_BREAKPOINT_PAGES = Object.freeze({
  ACCOUNT: 'account',
  ACCOUNT_MANAGEMENT: 'account_management',
  APP_SHELL: 'app_shell',
  ARCHIVED: 'archived',
  AUTH_VERIFY: 'auth_verify',
  CONNECTION_SIGN_IN: 'connection_sign_in',
  FLAGGED: 'flagged',
  FORGOT_PASSWORD: 'forgot_password',
  GLOBAL_OVERLAYS: 'global_overlays',
  LOGIN: 'login',
  MY_NETWORK: 'my_network',
  PLAYBAR: 'playbar',
  PLAYLIST: 'playlist',
  PLAYLIST_DETAIL: 'playlist_detail',
  PROFILE: 'profile',
  RECENTLY_PLAYED: 'recently_played',
  RELEASE_INFORMATION: 'release_information',
  RELEASES: 'releases',
  RESET_PASSWORD: 'reset_password',
  SEARCH: 'search',
  SETTINGS_PREFERENCES: 'settings_preferences',
  SIGNUP: 'signup'
})

// Add a page here once its v2 implementation is ready for controlled QA.
// Activate it remotely only after QA; Statsig cannot enable pages outside this list.
export const RESPONSIVE_V2_CAPABLE_PAGES = Object.freeze([
  RESPONSIVE_BREAKPOINT_PAGES.ACCOUNT,
  RESPONSIVE_BREAKPOINT_PAGES.ACCOUNT_MANAGEMENT,
  RESPONSIVE_BREAKPOINT_PAGES.APP_SHELL,
  RESPONSIVE_BREAKPOINT_PAGES.ARCHIVED,
  RESPONSIVE_BREAKPOINT_PAGES.AUTH_VERIFY,
  RESPONSIVE_BREAKPOINT_PAGES.CONNECTION_SIGN_IN,
  RESPONSIVE_BREAKPOINT_PAGES.FLAGGED,
  RESPONSIVE_BREAKPOINT_PAGES.FORGOT_PASSWORD,
  RESPONSIVE_BREAKPOINT_PAGES.GLOBAL_OVERLAYS,
  RESPONSIVE_BREAKPOINT_PAGES.LOGIN,
  RESPONSIVE_BREAKPOINT_PAGES.MY_NETWORK,
  RESPONSIVE_BREAKPOINT_PAGES.PLAYBAR,
  RESPONSIVE_BREAKPOINT_PAGES.PLAYLIST,
  RESPONSIVE_BREAKPOINT_PAGES.PLAYLIST_DETAIL,
  RESPONSIVE_BREAKPOINT_PAGES.PROFILE,
  RESPONSIVE_BREAKPOINT_PAGES.RECENTLY_PLAYED,
  RESPONSIVE_BREAKPOINT_PAGES.RELEASE_INFORMATION,
  RESPONSIVE_BREAKPOINT_PAGES.RESET_PASSWORD,
  RESPONSIVE_BREAKPOINT_PAGES.RELEASES,
  RESPONSIVE_BREAKPOINT_PAGES.SEARCH,
  RESPONSIVE_BREAKPOINT_PAGES.SETTINGS_PREFERENCES,
  RESPONSIVE_BREAKPOINT_PAGES.SIGNUP
])
